import { IUpdateChecklistServicoUseCase } from "../../../presentation/useCases/update/update_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateChecklistServicoUseCase
 */

export class UpdateChecklistServicoUseCase implements IUpdateChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateChecklistServico(
    idChecklistServico: number,
    ativo: boolean,
    codigo: string,
    nroRrevisao: string,
    descricao: string,
    tipoServico: number,
    unidade: string | null,
    campo1: string,
    campo2: string,
    campo3: string,
    campo4: string,
  ): Promise<void> {
    await this.repository.updateChecklistServico(
      idChecklistServico,
      ativo,
      codigo,
      nroRrevisao,
      descricao,
      tipoServico,
      unidade,
      campo1,
      campo2,
      campo3,
      campo4,
    );
  }
}
